var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kyc-chart-paging"},[_c('p',{staticClass:"kyc-chart-paging__counter"},[_vm._v(_vm._s(_vm.page)+" / "+_vm._s(_vm.pages))]),_c('kyc-chart-button-group',{attrs:{"buttons":_vm.buttons}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }